import { Box, FlexBox, Tooltip } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { ComponentProps, memo } from 'react';

import { CustomField } from 'utils/customFields';

import { CustomFieldDisplayValue } from '../customFieldDisplayValue/customFieldDisplayValue';

import styles from './customFieldChip.module.scss';

type CustomFieldChipProps = ComponentProps<typeof FlexBox> & {
  customField: CustomField;
};

/**
 * Presents a chip containing label and value if present. It also shows a
 * tooltip if there is description.
 */
export const CustomFieldChip = memo(function CustomFieldChip({
  className,
  customField,
  ...flexProps
}: CustomFieldChipProps): JSX.Element {
  const { attribute } = customField;

  return (
    <FlexBox
      className={classnames(styles.chip, className, {
        [styles.disabled]: attribute.is_archived || attribute.is_deactivated,
      })}
      alignItems="center"
      {...flexProps}
    >
      <Tooltip
        content={attribute.description}
        disabled={!attribute.description}
      >
        <Box className={styles.chipLabel}>{attribute.label}</Box>
      </Tooltip>

      {customField.value && (
        <CustomFieldDisplayValue
          customField={customField}
          className={styles.chipValueContainer}
        />
      )}
    </FlexBox>
  );
});
